import GenericContentSearch from './helpers/GenericContentSearch';

export default GenericContentSearch({
  search: { name: 'Attributes', type: 'Attribute', currentLanguageOnly: true },
});
